module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Regular.5ffec77.woff";